import "whatwg-fetch";

import * as React from "react";
import * as ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import * as Redux from "redux";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { default as App } from "./App";

import { persistListSettingsMiddleware } from "./middleware/persistListSettings";

import { Utilities } from "../shared/utilities";
import { SignalrListener } from "./middleware/signalrNotificationsProxy";
import * as AppPath from "./model/AppPath";
import { ConfirmDeleteDialogState } from "./model/ConfirmDeleteDialogState";
import { DeployDialogState } from "./model/DeployDialogState";
import { ListState } from "./model/ListState";
import { RunOnceDialogState } from "./model/RunOnceDialogState";
import { ProcessVariablesEditorState } from "./model/ProcessVariablesEditorState";
import { State } from "./model/State";
import * as reducers from "./reducers";
import { LinkNames } from "navigation/App";
import { renderNavBar } from "navigation";
import { Router, Route } from "react-router-dom";
import { executeMigrations } from "./migrations";
import { CleanOldVersionsDialogState } from "./model/CleanOldVersionsDialogState";
import StylesheetProvider from "shared/providers/StylesheetProvider";

executeMigrations();

renderNavBar(AppPath.processListHistory, LinkNames[AppPath.getProcessListType().toLowerCase() as keyof typeof LinkNames], AppPath.processListURLPattern);

const initialSearchState = AppPath.getInitialSearchState();
const initialAgentGroupEnvironment = AppPath.getAgentGroupEnvironmentFromPath();

const initialListState: ListState = Object.assign(new ListState(AppPath.isSubprocessList()), initialSearchState);
const initialState: State = {
    processes: [],
    processCount: 0,
    drafts: [],
    agentGroups: {},
    processCounts: {},
    availableTags: [],
    currentAgentGroupName: initialAgentGroupEnvironment.agentGroupName,
    listState: initialListState,
    deployDialogState: new DeployDialogState(),
    runOnceDialogState: new RunOnceDialogState(),
    confirmDeleteDialogState: new ConfirmDeleteDialogState(),
    loading: [],
    isSubprocessList: AppPath.isSubprocessList(),
    agentStatuses: {},
    logLevelDialogState: { showDialog: false },
    tasks: [],
    userPermissions: Utilities.getAllUserPermissions(),
    referencedProcessMap: {},
    usedInProcessesMap: {},
    usedProcessesMap: {},
    cleanOldVersionsDialogState: new CleanOldVersionsDialogState(),
    processVariablesEditorState: new ProcessVariablesEditorState(),
    environmentVariables: [],
    logLevelUsage: {},
    logRetentionUsage: {}
};

const composeEnhancer: typeof Redux.compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || Redux.compose;
const store = Redux.createStore(
    Redux.combineReducers(reducers),
    initialState,
    composeEnhancer(Redux.applyMiddleware(thunk as ThunkMiddleware<State, Redux.Action>, persistListSettingsMiddleware))
)
const subProcessListContainer = document.getElementById("ProcessListRootContainer");
if (subProcessListContainer) {
    const root = ReactDOM.createRoot(subProcessListContainer);
    const listener = new SignalrListener(store,
        () => {
            root.render(
                <React.StrictMode>
                    <StylesheetProvider>
                        <Provider store={store}>
                            <Router history={AppPath.processListHistory}>
                                <Route path={AppPath.processListURLPattern}>
                                    <App initialSearchState={initialSearchState} initialAgentGroupEnvironment={initialAgentGroupEnvironment} />
                                </Route>
                            </Router>
                        </Provider>
                    </StylesheetProvider>
                </React.StrictMode>
            );
        });
}